<template>
  <v-container
    class="fill-height"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        v-if="registerView"
        sm="6"
      >
        <v-card>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline">
                Registro de Estudiante
              </v-list-item-title>
              <v-list-item-subtitle>Crea tu cuenta</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="tutorEmail"
                    label="Correo electrónico Tutor"
                    prepend-icon="mdi-email"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="email"
                    label="Correo electrónico Estudiante"
                    prepend-icon="mdi-email"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="nickname"
                    label="Nombre de usuario"
                    prepend-icon="mdi-account"
                    :rules="nicknameRules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="firstname"
                    label="Nombre"
                    prepend-icon="mdi-account"
                    :rules="firstnameRules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="lastname"
                    label="Apellido"
                    prepend-icon="mdi-account"
                    :rules="lastnameRules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="password"
                    label="Contraseña"
                    prepend-icon="mdi-lock"
                    type="password"
                    :rules="passRules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="password_confirm"
                    label="Confirma Contraseña"
                    prepend-icon="mdi-lock"
                    type="password"
                    :rules="password_confirmRules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-menu
                    ref="menuBirthday"
                    v-model="menuBirthday"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="birth_date_computed"
                        label="Fecha de nacimiento"
                        prepend-icon="mdi-cake-variant"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="birth_date"
                      locale="es"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @change="save"
                    />
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="country"
                    :items="countryOptions"
                    label="País"
                    :rules="countryRules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="region"
                    :items="regionOptions"
                    item-text="name"
                    label="Región/Provincia"
                    :disabled="regionOptions.length < 1"
                    :rules="regionRules"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <template>
            <v-btn
              block
              class="primary"
              @click="register"
            >
              Crear Cuenta
            </v-btn>
            <v-btn
              class="blue darken-1"
              block
              @click="home"
            >
              ¿Ya tienes una cuenta? Inicia sesión
            </v-btn>
          </template>
        </v-card>
      </v-col>
      <v-col
        v-else
        sm="6"
      >
        <v-card
          color="#616161"
          dark
          height="100"
        >
          <v-card-title
            class="headline d-flex justify-center"
          >
            {{ msg }}
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { auth } from '@/firebase'
  import firebase from 'firebase/app'
  import regions from './data.js'
  import axios from 'axios'
  export default {
    data () {
      return {
        msg: '',
        registerView: true,
        regions,
        register_url:
          'https://us-central1-videojuego-sh.cloudfunctions.net/registerStudent',
        token: '',
        license: '',
        tutorEmail: '',
        studentsLength: 0,
        licenses: 0,
        regionOptions: [],
        groupId: null,
        menuBirthday: false,
        showPassword1: false,
        showPassword2: false,
        type: 'tutor',
        login_url:
          'https://us-central1-videojuego-sh.cloudfunctions.net/loginPlayer',
        e1: 1,
        nicknameRules: [(v) => !!v || 'Usuario es requerido'],
        firstnameRules: [(v) => !!v || 'Nombre es requerido'],
        lastnameRules: [(v) => !!v || 'Apellifo es requerido'],
        passRules: [(v) => !!v || 'Contraseña es requerido'],
        password_confirmRules: [
          (v) => !!v || 'Confirmar contraseña es requerido',
          (v) => v === this.password || 'Contraseña no es igual',
        ],
        countryRules: [(v) => !!v || 'País es requerido'],
        regionRules: [(v) => !!v || 'Ciudad es requerido'],
        nickname: '',
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        password_confirm: '',
        birth_date: new Date().toISOString().substr(0, 10),
        country: '',
        region: '',
        currentYear: null,
      }
    },
    computed: {
      birth_date_computed: {
        get: function () {
          return this.formatDate(this.birth_date)
        },
        set: function (newValue) {
          console.log(newValue)
        },
      },
      countryOptions () {
        return this.regions.map(c => c.countryName)
      },
    },
    watch: {
      menuBirthday (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
      country (val) {
        this.regionOptions = this.regions
          .filter((c) => c.countryName === val)
          .flatMap((r) => r.regions)
      },
    },
    beforeMount () {
      var currentDate = new Date()
      this.currentYear = currentDate.getFullYear().toString()
    },
    mounted () {
      auth.signOut()
      this.init()
    },
    methods: {
      init () {
        this.nickname = ''
        this.firstname = ''
        this.lastname = ''
        this.password = ''
        this.country = ''
        this.region = ''
        this.password_confirm = ''

        this.$store.commit('SET_LOADING', true)
        this.token = this.$route.query.token
        firebase
          .auth()
          .signInWithCustomToken(this.token)
          .then((response) => {
            this.getToken(this.token)
          })
          .catch((error) => {
            console.log(error)
            this.msg = 'Invitación caducada o inválida.'
            this.registerView = false
            this.$store.commit('SET_LOADING', false)
          })
      },
      getToken (token) {
        firebase
          .firestore()
          .collection('tokens')
          .doc(token)
          .get()
          .then((response) => {
            const data = response.data()
            const completed = data.completed

            if (completed) {
              this.msg = 'La invitación ya ha sido registrada.'
              this.registerView = false
              this.$store.commit('SET_LOADING', false)
              return
            }

            const expirationDate = data.expiration_date.toDate()
            const currentDate = firebase.firestore.Timestamp.now().toDate()

            if (currentDate >= expirationDate) {
              this.msg = 'La invitación ya caducó.'
              this.registerView = false
              this.$store.commit('SET_LOADING', false)
              return
            }

            const tutor = data.tutor
            this.email = data.email
            this.groupId = data.groupId
            this.license = data.license
            this.getTutor(tutor)
          })
          .catch((error) => {
            console.log(error)
            this.msg = 'Invitación caducada o inválida.'
            this.registerView = false
            this.$store.commit('SET_LOADING', false)
          })
      },
      getTutor (uid) {
        firebase
          .firestore()
          .collection('users')
          .doc(uid)
          .get()
          .then((response) => {
            const data = response.data()
            this.tutorEmail = data.email
            var students =
              typeof data.students !== 'undefined' ? data.students : []

            this.studentsLength = students.length
            this.licenses = data.licensesQuantity
            if (this.studentsLength + 1 > this.licenses) {
              alert('Límite de estudiantes superado.')
            }
            this.$store.commit('SET_LOADING', false)
          })
          .catch((error) => {
            this.$store.commit('SET_LOADING', false)
            console.log(error)
            alert(error)
          })
      },
      home () {
        this.$router.push({ name: 'Home' })
        console.log("home():", from.path, to.path, auth.currentUser);
      },
      save (date) {
        this.$refs.menuBirthday.save(date)
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      register () {
        if (this.$refs.form.validate()) {
          this.$store.commit('SET_LOADING', true)
          firebase
            .auth()
            .createUserWithEmailAndPassword(this.email, this.password)
            .then((response) => {
              this.sendEmail(response.user)
              this.registerPost(response.user.uid)
            })
            .catch((error) => {
              this.$store.commit('SET_LOADING', false)
              alert(error)
            })
        } else {
          this.$store.commit('SET_LOADING', false)
          console.log('Error en el formulario: faltan datos')
        }
      },
      sendEmail (user) {
        user.sendEmailVerification()
      },
      registerPost (userId) {
        var location = {
          country: this.country,
          region: this.region,
        }

        axios
          .post(this.register_url, {
            user_id: userId,
            tutor: this.tutorEmail,
            email: this.email,
            firstname: this.firstname,
            lastname: this.lastname,
            nickname: this.nickname,
            birth_date: this.birth_date,
            type: 'student',
            groupId: this.groupId,
            tokenId: this.token,
            licenseId: this.license,
            location,
          })
          .then((response) => {
            const data = response.data
            const error = data.error
            if (!error) {
              const message = data.message
              alert('Gracias por registrarse, verifique su correo.')
              console.log(message)
              this.goToHome()
            }
            this.$store.commit('SET_LOADING', false)
          })
      },
      goToHome () {
        this.$store.commit('SET_LOADING', false)
        this.$router.replace({ path: 'home' })

        console.log("gotoHome:", from.path, to.path, auth.currentUser);

      },
    },
  }
</script>
